export const SAVE_ALL_TIME_INTERVALS = 'SAVE_ALL_TIME_INTERVALS'